import Icon from 'components/Icon'
import { useEffect, useRef, useState } from 'react'

// Hooks
import useAuth from 'hooks/useAuth'
import { Button, Form } from 'react-bootstrap'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import '../../scss/components/login-modal.scss'
import Image from 'components/Image'
import { useDispatch, useSelector } from 'react-redux'
import toast from 'react-hot-toast'

import { setUser } from 'redux/stateSlice'

const LoginModal = () => {
  let auth = useAuth()
  let navigate = useNavigate()
  let location = useLocation()
  let dispatch = useDispatch()

  const { currentUser } = useSelector(state => state.state)

  const emailInput = useRef()

  const [email, setEmail] = useState(currentUser ? currentUser.email : '')
  const [isCapsOn, setIsCapsOn] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [forgottonPassword, setIsPwdTab] = useState(false)
  const [forgottonPasswordSent, setForgottenPwdSent] = useState(false)

  let from = location.state?.from?.pathname || '/'

  useEffect(() => {
    if (currentUser) {
      setEmail(currentUser.email)
      // User just logged in — ensure the login modal is closed and its body overlay is removed
      setIsOpen(false)
      document.body.classList.remove('modal-open')
    }
  }, [currentUser])

  function handleSubmit(event) {
    event.preventDefault()

    let formData = new FormData(event.currentTarget)

    let credentials = {
      loginName: formData.get('userName'),
      password: formData.get('password'),
      rememberMe: formData.get('rememberMe'),
    }

    if (process.env.REACT_APP_SPOOF) {
      auth.spoof(() => navigate(from, { replace: true }))
    } else {
      auth.signin(credentials, res => dispatch(setUser(res)))
    }
  }

  function handleForgottenPassword(event) {
    event.preventDefault()

    let formData = new FormData(event.currentTarget)

    let credentials = {
      loginName: formData.get('userName'),
    }

    setForgottenPwdSent(true)

    auth.forgottenPassword(credentials)
  }

  const checkCapsLock = e => {
    setIsCapsOn((e.getModifierState && e.getModifierState('CapsLock')) || false)
  }

  useEffect(() => {
    window.addEventListener('keyup', checkCapsLock)
    window.addEventListener('keydown', checkCapsLock)
    if (emailInput.current) {
      emailInput.current.focus()
    }
    document.documentElement.classList.add('html-login-view')
    return () => {
      window.removeEventListener('keyup', checkCapsLock)
      window.removeEventListener('keydown', checkCapsLock)
      document.documentElement.classList.remove('html-login-view')
    }
  }, [])

  useEffect(() => {
    if (isOpen) {
      toggleOpen()
    }
    setDropdownOpen(false)
  }, [location])

  const toggleOpen = () => {
    isOpen ? setIsOpen(false) : setIsOpen(true)
    isOpen ? document.body.classList.remove('modal-open') : document.body.classList.add('modal-open')
  }

  const togglePwdTab = () => {
    forgottonPassword ? setIsPwdTab(false) : setIsPwdTab(true)
    forgottonPassword ? setForgottenPwdSent(false) : setForgottenPwdSent(forgottonPasswordSent)
  }

  if (currentUser) {
    return (
      <div className={'account-btn-container has-children-account' + (dropdownOpen ? ' dropdown-open' : '')}>
        <button onClick={() => setDropdownOpen(!dropdownOpen)} className="login-toggle">
          <p>Hi, {currentUser.username}</p>
          <Icon name="baliMyna" />
        </button>
        <div className="account-dropdown">
          <Link to="/account" onClick={() => setDropdownOpen(false)}>
            Account Details
          </Link>
          {currentUser.hasActiveSubscription && (
            <>
              {/* <Link to="/members/useful-links" onClick={() => setDropdownOpen(false)}>
                Useful Links
              </Link> */}
              <Link to="/members/adverts" onClick={() => setDropdownOpen(false)}>
                Adverts
              </Link>
              <Link to="/account/adverts" onClick={() => setDropdownOpen(false)}>
                My Adverts
              </Link>
            </>
          )}
          <button
            onClick={() => {
              setDropdownOpen(false)
              auth.signout(() => navigate('/'))
            }}>
            Logout
          </button>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="account-btn-container">
        <Link to={'/join'} className={'join-toggle'}>
          JOIN NOW
        </Link>

        <button onClick={toggleOpen} className={'login-toggle'}>
          <p>Members Login</p>
          <Icon name="baliMyna" />
        </button>
      </div>

      <div className={'modal login-modal' + (isOpen ? ' open' : '')}>
        {isOpen && (
          <>
            <Button variant="transparent" onClick={toggleOpen} className="">
              <Icon name="close" />
              <span>Close</span>
            </Button>
            <div>
              {forgottonPassword ? (
                <Form onSubmit={handleForgottenPassword} className="forgotten-pwd">
                  <h2>Forgotten Password</h2>

                  {!forgottonPasswordSent ? (
                    <>
                      <Form.Control
                        name="userName"
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="Email"
                        ref={emailInput}
                        autoComplete="username"
                      />
                      <Button className="button green1" type="submit">
                        Send Password Reset
                      </Button>

                      <Button className="button green1 inverted" type="back" onClick={togglePwdTab}>
                        Back
                      </Button>
                    </>
                  ) : (
                    <>
                      <span>Password Reset Sent. Please check your emails.</span>
                      <Button className="button green1 inverted" type="back" onClick={togglePwdTab}>
                        Back
                      </Button>
                    </>
                  )}
                </Form>
              ) : (
                <Form onSubmit={handleSubmit} className="login">
                  <h2>Members Login</h2>

                  <Form.Group>
                    <Form.Control
                      name="userName"
                      type="email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      placeholder="Email"
                      ref={emailInput}
                      autoComplete="username"
                    />
                  </Form.Group>

                  <span className={`text-info mb-3 ${isCapsOn ? '' : ' hidden'}`}>WARNING: Caps Lock is on!</span>

                  <Form.Group>
                    <Form.Control name="password" type="password" placeholder="Password" autoComplete={'current-password'} />
                  </Form.Group>

                  <Form.Check type="checkbox" className="remember-me">
                    <Form.Check.Input name="rememberMe" id="remember-me" type="checkbox" />
                    <Form.Check.Label className="" htmlFor="remember-me">
                      Remember me
                    </Form.Check.Label>
                  </Form.Check>
                  <p className="forgot-password" to="forgot-password" onClick={togglePwdTab}>
                    <u>Forgot Password?</u>
                  </p>

                  <Button className="button green1" type="submit">
                    LOGIN
                  </Button>
                  <p>
                    Dont have an account?{' '}
                    <Link to={'join'} className="underline strong">
                      Become a member
                    </Link>
                  </p>
                </Form>
              )}
            </div>
            <div>
              <Image name={'kingfishers'} blowout={{ imageSize: 500, blowoutSize: 50, id: 'kingfishers' }} />
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default LoginModal
